import type {
  CardGenderType,
  CardHRType,
  CardIndustryCategoryJaType,
  CardRemoteFrequencyJaType,
} from "../components/EmailCard";

// 技術スキル情報を隠すしきい値
export const TECH_ROW_LIMIT = 8;

export const industryCategoryMap: Record<string, CardIndustryCategoryJaType> = {
  finance: "金融",
  insurance: "保険",
  government: "官公庁",
  manufacturing: "製造業",
  healthcare: "医療",
  education: "教育",
  retail: "小売",
  startup: "スタートアップ",
};

export const remoteFrequencyMap: Record<string, CardRemoteFrequencyJaType> = {
  full_remote: "フルリモート",
  hybrid: "リモート併用",
  onsite_only: "常駐勤務",
};

export const genderMap: Record<string, CardGenderType> = {
  male: "男性",
  female: "女性",
};

export const hrMap: Record<string, CardHRType> = {
  fullTimeEmployee: "正社員",
  contractEmployee: "契約社員",
  freelancer: "フリーランス",
};
